import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import dayjs from 'dayjs';

/** 积分上线日期 */
const WEPOINTS_PUBLISH_DATE = new Date('2024/01/01 00:00:00');
/** 是否展示积分 */
export const isShowWepoints = () => window.__isShowWepoints__ || dayjs(getServerTime()).isAfter(WEPOINTS_PUBLISH_DATE);
/**
 * 积分组件投放位置
 * dev: 1100045616880003
*/
export const WE_POINTS_DP_POSITION = '1100040000330002';
